document.addEventListener("DOMContentLoaded", function () {
    function imageCarousel(section = document) {
        let imageCarouselElements = section.querySelectorAll('[data-image-carousel]');
        Array.from(imageCarouselElements).forEach(function (imageCarouselElement) {
            imageCarouselElement.addEventListener('mouseover', function () {
                if (imageCarouselElement.classList.contains('active')) return;

                let parentSection = imageCarouselElement.closest('.shopify-section');
                if (!parentSection) return;

                let activeItem = parentSection.querySelector(".images-carousel-content-item.active");
                let preId = activeItem ? activeItem.getAttribute("id") : null;
                
                if (activeItem) {
                    activeItem.classList.remove('active');
                }
                imageCarouselElement.classList.add('active');

                let currentId = imageCarouselElement.getAttribute("id");
                let previousActives = parentSection.querySelectorAll(".images-carousel-img.active");

                Array.from(previousActives).forEach(function (previousActive) {
                    let previousActiveIndex = previousActive.getAttribute("data-id");
                    if (previousActiveIndex && previousActiveIndex !== currentId) {
                        let prevImage = parentSection.querySelector(`.images-carousel-img[data-id='${previousActiveIndex}']`);
                        if (prevImage) {
                            prevImage.classList.remove("active");
                            prevImage.classList.add("processing");
                            prevImage.style.zIndex = 2;
                        }
                    }
                });

                setTimeout(function () {
                    Array.from(previousActives).forEach(function (previousActive) {
                        let previousActiveIndex = previousActive.getAttribute("data-id");
                        if (previousActiveIndex && previousActiveIndex !== currentId) {
                            let prevImage = parentSection.querySelector(`.images-carousel-img[data-id='${previousActiveIndex}']`);
                            if (prevImage) {
                                prevImage.classList.remove("processing");
                                prevImage.style.zIndex = 1;
                            }
                        }
                    });
                }, 300);

                let imageDetailsItem = parentSection.querySelector(`.images-carousel-img[data-id='${currentId}']`);
                if (imageDetailsItem) {
                    imageDetailsItem.classList.add("active");
                    imageDetailsItem.style.zIndex = 3;
                }

                let activeDescItem = parentSection.querySelector(".images-carousel-content-description.active");
                if (activeDescItem && preId !== currentId) {
                    activeDescItem.classList.remove("active");
                    activeDescItem.style.display = "none";
                }

                let currentActiveDesc = parentSection.querySelector(`.images-carousel-content-description[data-id='${currentId}']`);
                if (currentActiveDesc) {
                    currentActiveDesc.classList.add("active");
                    
                    // Smooth fade-in effect using JavaScript
                    currentActiveDesc.style.display = "block";
                    currentActiveDesc.style.opacity = 0;
                    let opacity = 0;
                    let fadeInEffect = setInterval(function () {
                        if (opacity < 1) {
                            opacity += 0.1;
                            currentActiveDesc.style.opacity = opacity;
                        } else {
                            clearInterval(fadeInEffect);
                        }
                    }, 30);
                }
            });
        });
    }

    imageCarousel(); // Initialize the function
});
